import { render, staticRenderFns } from "./MicMenu.vue?vue&type=template&id=23cbc776&scoped=true"
import script from "./MicMenu.vue?vue&type=script&lang=js"
export * from "./MicMenu.vue?vue&type=script&lang=js"
import style0 from "./MicMenu.vue?vue&type=style&index=0&id=23cbc776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cbc776",
  null
  
)

export default component.exports